import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "TaskOperationExtraReasonListPage" */
	'pages/intervention/TaskOperationExtraReason/TaskOperationExtraReasonListPage'));

export default [{ component, exact: true, path: '/task_operation_extra_reasons' }];